export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkPricing: "nav-link-pricing",
  linkWedding: "nav-link-wedding",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaCall: "nav-cta-call",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-root",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaPricing: "hero-cta-pricing",
  ctaContact: "hero-cta-contact",
};

export const STATS = {
  root: "stats-root",
  item: (key) => `stat-${key}`,
};

export const WEDDING = {
  root: "wedding-root",
  callAnna: "wedding-call-anna",
  ctaQuote: "wedding-cta-quote",
  video: "wedding-video",
};

export const PRICING = {
  root: "pricing-root",
  card: (id) => `pricing-card-${id}`,
  cta: (id) => `pricing-cta-${id}`,
};

export const SERVICES = {
  root: "services-root",
  card: (id) => `service-card-${id}`,
};

export const VIDEO = {
  root: "video-showcase",
  iframe: "video-showcase-iframe",
};

export const ABOUT = {
  root: "about-root",
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  phone: "contact-input-phone",
  eventType: "contact-input-event-type",
  eventTypeTrigger: "contact-input-event-type-trigger",
  message: "contact-input-message",
  submit: "contact-submit",
  callBtn: "contact-call-btn",
  success: "contact-success",
};

export const FOOTER = {
  root: "footer-root",
};
